import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams, createSearchParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Select, SearchBar } from "../../../components";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { SendIcon } from "../../../components/icons";
import { useContacts } from "../hooks";
import { CustomerSelectSearch } from "../../customers/components";
import { cleanObject } from "../../../helpers/clean-object";

interface ISearchForm {
  search?: string;
  active?: string;
  customerId?: string;
}

export const Contacts: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const form = useForm<ISearchForm>({
    mode: "all",
    defaultValues: {
      search: searchParams.get("search") ?? "",
      active: searchParams.get("active") ?? "",
      customerId: searchParams.get("customerId") ?? "",
    },
  });

  const onSubmit = () => {
    const values = form.getValues();
    navigate({
      pathname: "/contacts",
      search: `?${createSearchParams(cleanObject(values))}`,
    });
  };

  const search = searchParams.get("search");
  const active = searchParams.get("active");
  const customerId = searchParams.get("customerId");

  const where: any = {};
  if (search) where.search = search;
  if (active) where.active = active === "true";
  if (customerId) where.customerId = +customerId;

  const { data, loading } = useContacts({ where });

  return (
    <>
      <Header
        title="Contacts"
        subtitle="Liste des contacts"
        buttons={[
          {
            actionText: "Nouveau contact",
            bgColor: "indigo",
            textColor: "white",
            link: `/contact/create`,
            icon: <SendIcon />,
          },
        ]}
      />

      <div className="main-container">
        <SearchBar
          form={form}
          onSubmit={onSubmit}
          placeholder="Rechercher un contact..."
          advancedFilters={
            <>
              <CustomerSelectSearch form={form} name="customerId" />
              <Select label="Actif" className="w-full" {...form.register("active")}>
                <option value="">Tous</option>
                <option value="true">Oui</option>
                <option value="false">Non</option>
              </Select>
            </>
          }
        />

        <div className="p-4 mb-6 bg-white shadow rounded overflow-x-auto">
          {loading ? (
            <Loading />
          ) : !data?.contacts?.results?.length ? (
            <EmptyList text="Aucun contact" />
          ) : (
            <Table>
              <TableHeader>
                <TableRow hover={false}>
                  <TableCell header>Nom</TableCell>
                  <TableCell header>Client</TableCell>
                  <TableCell header align="center">
                    Principal
                  </TableCell>
                  <TableCell header align="center">
                    Actif
                  </TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data?.contacts?.results?.map((contact) => (
                  <TableRow
                    key={`contact-${contact.id}`}
                    onClick={() => navigate(`/contact/${contact.id}`)}
                  >
                    <TableCell>
                      {contact.firstname} {contact.lastname}
                    </TableCell>
                    <TableCell>{contact.customer?.name}</TableCell>
                    <TableCell align="center">
                      {contact.isPrimary ? "Oui" : "Non"}
                    </TableCell>
                    <TableCell align="center">
                      {contact.active ? "Oui" : "Non"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </div>
    </>
  );
};
